<header class="admin-header flex items-center justify-between px-4 py-4 md:px-8 md:py-5">
  <div>
    <p class="admin-header__eyebrow">Espace d’administration</p>
    <p class="admin-header__title font-semibold text-xl md:text-2xl">Bonjour {{ userFirstname }},</p>
  </div>
  <button type="button" (click)="logout()" class="admin-logout-button">
    <span class="admin-logout-button__dot" aria-hidden="true"></span>
    Déconnexion
  </button>
</header>
